import React from "react";

// The signature illuminated ViewBox frame — glowing corners + subtle scanline.
// Kept intentionally minimal so we can drop it around any content.
export function ViewBoxFrame({ children, className = "", tone = "light" }) {
  const isDark = tone === "dark";
  return (
    <div className={`vb-frame ${isDark ? "vb-frame-dark" : ""} ${className}`}>
      <span className="vb-corner vb-corner-tl" />
      <span className="vb-corner vb-corner-tr" />
      <span className="vb-corner vb-corner-bl" />
      <span className="vb-corner vb-corner-br" />
      <span className="vb-scan" />
      <div className="relative z-10 h-full w-full">{children}</div>
    </div>
  );
}

// Small ViewBox logo mark
export function ViewBoxMark({ size = 24, glow = true }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="vb-mark-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#10B981" />
          <stop offset="1" stopColor="#0EA5E9" />
        </linearGradient>
        {glow && (
          <filter id="vb-mark-glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="1.2" />
          </filter>
        )}
      </defs>
      <rect x="4" y="4" width="24" height="24" rx="4"
            stroke="url(#vb-mark-grad)" strokeWidth="2" fill="none" />
      {glow && <rect x="4" y="4" width="24" height="24" rx="4"
                     stroke="url(#vb-mark-grad)" strokeWidth="1"
                     filter="url(#vb-mark-glow)" opacity="0.7" />}
      <circle cx="16" cy="16" r="3" fill="url(#vb-mark-grad)" />
      <line x1="16" y1="2" x2="16" y2="6" stroke="url(#vb-mark-grad)" strokeWidth="2" strokeLinecap="round" />
      <line x1="16" y1="26" x2="16" y2="30" stroke="url(#vb-mark-grad)" strokeWidth="2" strokeLinecap="round" />
      <line x1="2" y1="16" x2="6" y2="16" stroke="url(#vb-mark-grad)" strokeWidth="2" strokeLinecap="round" />
      <line x1="26" y1="16" x2="30" y2="16" stroke="url(#vb-mark-grad)" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
